import DatePicker from 'components/form/DatePicker';
import TextArea from 'components/form/TextArea';
import TextInput from 'components/form/TextInput';
import React from 'react';
// Session-Based Publication Opportunities and Conference Outcomes at [Conference Name]
const FourthStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values } = props;
  const { values, errors, touched, handleChange, handleBlur } = props;
  const {
    client_name,
    paper_title,
    conference_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    registration_link,
    sdg_name_number,
    sdg_brif_explanation,
    your_name,
    contact_details,
  } = values;
  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Client Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Paper Title
        </div>
        <div className="col-lg-6">
          <TextInput
            id="paper_title"
            onChange={handleChange}
            value={paper_title}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.paper_title && errors.paper_title}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_name"
            onChange={handleChange}
            value={conference_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_name && errors.conference_name}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference From Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_from_date"
            onChange={handleChange}
            value={conference_from_date}
            disabled={!isEdit}
            error={errors.conference_from_date}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference To Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_to_date"
            onChange={handleChange}
            value={conference_to_date}
            disabled={!isEdit}
            error={errors.conference_to_date}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">Venue</div>
        <div className="col-lg-6">
          <TextInput
            id="conference_location"
            onChange={handleChange}
            value={conference_location}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_location && errors.conference_location}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          SDG Name & Number
        </div>
        <div className="col-lg-6">
          <TextInput
            id="sdg_name_number"
            onChange={handleChange}
            value={sdg_name_number}
            disabled={!isEdit}
            suggestions={suggestionData?.sdg_name_number}
            onBlur={handleBlur}
            error={touched.sdg_name_number && errors.sdg_name_number}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Brief explanation
        </div>
        <div className="col-lg-6">
          <TextArea
            id="sdg_brif_explanation"
            onChange={handleChange}
            value={sdg_brif_explanation}
            disabled={!isEdit}
            error={errors.sdg_brif_explanation}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Register Here
        </div>
        <div className="col-lg-6">
          <TextInput
            id="registration_link"
            onChange={handleChange}
            value={registration_link}
            disabled={!isEdit}
            suggestions={suggestionData?.registration_link}
            onBlur={handleBlur}
            error={touched.registration_link && errors.registration_link}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_name"
            onChange={handleChange}
            value={your_name}
            disabled={!isEdit}
            suggestions={suggestionData?.your_name}
            onBlur={handleBlur}
            error={touched.your_name && errors.your_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Contact Details
        </div>
        <div className="col-lg-6">
          <TextInput
            id="contact_details"
            onChange={handleChange}
            value={contact_details}
            disabled={!isEdit}
            suggestions={suggestionData?.contact_details}
            onBlur={handleBlur}
            error={touched.contact_details && errors.contact_details}
          />
        </div>
      </div>
    </>
  );
};

export default FourthStepOfFollowUps;
